module.exports = __webpack_public_path__ + "img/on-site-rescue.7ef08ac7.png";